<template>
    <div class="chat-widget-wrap">
        <div class="chat-widget" :class="{ 'mobile-active': isChatActive }">
            <div class="tabs row mx-0">
                <div class="col-auto px-0">
                    <div class="back-arrow" v-if="isChatActive" @click="resetChatState">
                        ⬅ Back
                    </div>
                    <div class="message-heading">{{ $t('property_detail.messages') }}</div>
                    <div class="search-box mb-search-box" v-if="!isChatActive">
                        <form>
                            <input type="text" v-model="searchQuery" :placeholder="$t('messages.search_participant')"
                                class="search-input" />
                        </form>
                    </div>
                    <ul class="nav nav-pills flex-column card-header h-100 border-bottom-0 rounded-0">
                        <li v-if="filteredConversations.length === 0"
                            class="nav-item chat-text text-center text-muted py-3" style="width: 100%;">
                            {{ $t('messages.no_chat') }}
                        </li>
                        <li v-for="conversation in filteredConversations" :key="conversation.id" class="nav-item"
                            :class="{ active: activeConversation && activeConversation.id === conversation.id, inactive: activeConversation && activeConversation.id !== conversation.id }">
                            <div class="nav-link" @click="selectConversation(conversation)">
                                <div class="d-flex align-items-center justify-content-between w-100">
                                    <div class="d-flex align-items-center message-list">
                                        <img src="https://www.vanovy.com/public/images/mountains.png"
                                            alt="User" />
                                        <span>{{ getSecondUserName(conversation) }}</span>
                                    </div>
                                    <div v-if="conversation.unreadCount" class="message-badge">
                                        <span>{{ conversation.unreadCount }}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="chat-tab-content" v-if="filteredConversations.length === 0">
                    <div class="card-box">
                        <img src="../public/assets/images/ChatIcon.png" alt="ChatIcon" />
                        <p>{{ $t('messages.no_chat') }}</p>
                    </div>
                </div>
                <div class="tab-content col" v-else-if="activeConversation">
                    <div class="tab-pane active">
                        <div class="card-text">
                            <div class="single-chat-header d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <img src="https://www.vanovy.com/public/images/mountains.png"
                                        alt="User" />
                                    <span>{{ getSecondUserName(activeConversation) }}</span>
                                </div>
                                <div>
                                    <button class="btn btn-sm btn-outline-primary font-weight-bold" @click="openCreateAgreementModal">
                                        <i class="fa fa-file-text-o mr-1"></i> Create Agreement
                                    </button>
                                </div>
                            </div>
                            <div class="chat-box" ref="chatBox">
                                <div v-for="(group, date) in messages" :key="date">
                                    <div class="date-box">{{ date }}</div>

                                    <div v-for="message in group" :key="message.id" class="message-text"
                                        :class="{ send: isMyMessage(message), 'new-message-indicator': message.isIndicator }">

                                        <!-- Show indicator for new messages -->
                                        <template class="date-box new-message" v-if="message.isIndicator">
                                            <span>{{ $t('messages.new_messages') }}</span>
                                        </template>

                                        <!-- Show rental agreement card message -->
                                        <template v-else-if="isAgreementMessage(message)">
                                            <div class="rental-agreement-card p-3 bg-white border rounded text-dark shadow-sm my-2" style="max-width: 360px;">
                                                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                                                    <div class="d-flex align-items-center">
                                                        <i class="fa fa-file-text text-primary mr-2" style="font-size: 18px;"></i>
                                                        <strong style="font-size: 14px;">Rental Agreement</strong>
                                                    </div>
                                                    <span class="badge" :class="getAgreementBadgeClass(getAgreementObject(message))">{{ getAgreementObject(message) ? (getAgreementObject(message).status || 'Pending Signature') : 'Pending Signature' }}</span>
                                                </div>
                                                <div class="mb-2" style="font-size: 13px;">
                                                    <div><strong>Property:</strong> {{ getAgreementObject(message) ? (getAgreementObject(message).propertyTitle || getAgreementObject(message).property_title || 'Residential Property') : 'Residential Property' }}</div>
                                                    <div><strong>Rent:</strong> AED {{ getAgreementObject(message) ? (getAgreementObject(message).monthlyRent || getAgreementObject(message).monthly_rent || '0.00') : '0.00' }} / month</div>
                                                    <div v-if="getAgreementObject(message) && (getAgreementObject(message).startDate || getAgreementObject(message).start_date)"><strong>Duration:</strong> {{ formatShortDate(getAgreementObject(message).startDate || getAgreementObject(message).start_date) }} to {{ formatShortDate(getAgreementObject(message).endDate || getAgreementObject(message).end_date) }}</div>
                                                </div>
                                                <div class="pt-2 border-top mt-2 d-flex justify-content-between">
                                                    <button class="btn btn-sm btn-primary flex-grow-1 mr-1" @click="openViewAgreementModal(getAgreementObject(message), message.sender_id)">
                                                        <i class="fa fa-eye mr-1"></i> View / Sign
                                                    </button>
                                                    <a v-if="getAgreementPdfUrl(getAgreementObject(message))" :href="getAgreementPdfUrl(getAgreementObject(message))" target="_blank" class="btn btn-sm btn-outline-danger px-2">
                                                        <i class="fa fa-file-pdf-o mr-1"></i> PDF
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="message-time">{{ formatMessageTime(message.created_at) }}</div>
                                        </template>

                                        <!-- Show actual messages -->
                                        <template v-else>
                                            <span>{{ message.content }}</span>
                                            <div class="message-time">{{ formatMessageTime(message.created_at) }}</div>
                                        </template>

                                    </div>
                                </div>
                            </div>

                            <div class="single-chat-footer">
                                <div class="write-message">
                                    <b-form-textarea id="textarea-rows" v-model="newMessage"
                                        :placeholder="$t('messages.write_something')" rows="1"
                                        @keydown.enter.prevent="sendMessage"></b-form-textarea>
                                </div>
                                <div class="send-message">
                                    <button @click="sendMessage">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path
                                                d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Modals for Rental Agreement Creation & Viewing -->
        <CreateRentalAgreementModal ref="createAgreementModal" :conversation-id="activeConversationId" @agreement-created="handleAgreementCreated" />
        <ViewRentalAgreementModal ref="viewAgreementModal" @agreement-signed="handleAgreementSigned" :current-user-id="loggedInUserId" />
    </div>
</template>

<script>
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import API from "../api";
import DOMPurify from "dompurify";
import CreateRentalAgreementModal from "../components/CreateRentalAgreementModal.vue";
import ViewRentalAgreementModal from "../components/ViewRentalAgreementModal.vue";

export default {
    components: {
        CreateRentalAgreementModal,
        ViewRentalAgreementModal
    },
    data() {
        return {
            searchQuery: "",
            isChatActive: false,
            conversations: [],
            messages: [],
            activeConversation: null,
            newMessage: "",
            channel: null,
            newMessageIndicator: false,
            windowWidth: window.innerWidth // Track window width
        };
    },
    computed: {
        loggedInUserId() {
            try {
                const u = JSON.parse(localStorage.getItem("user"));
                return u ? (u.id || u.user_id || (u.user && u.user.id)) : null;
            } catch (e) {
                return null;
            }
        },
        activeConversationId() {
            return this.activeConversation ? this.activeConversation.id : null;
        },
        filteredConversations() {
            if (!this.searchQuery) return this.conversations;
            return this.conversations.filter(conversation => {
                const participantName = this.getSecondUserName(conversation).toLowerCase();
                return participantName.includes(this.searchQuery.toLowerCase());
            });
        },
        isMobileOrTablet() {
            return this.windowWidth <= 991; // Match CSS breakpoint
        }
    },
    methods: {
        initializeEcho() {
            window.Pusher = Pusher;
            window.Echo = new Echo({
                broadcaster: "pusher",
                key: "1ada00abfffc7b2708d1",
                cluster: "eu",
                forceTLS: true
            });

            window.Echo.channel('conversation.' + this.loggedInUserId)
                .listen('.conversation.created', (data) => {
                    console.log('New conversation created', data.conversation);
                    const existingConversation = this.conversations.find(c => c.id === data.conversation.id);
                    if (!existingConversation) {
                        this.fetchConversations();
                    }
                });
        },
        fetchConversations() {
            API.getConversations(
                (data) => {
                    this.conversations = data.conversations;
                    this.conversations.forEach((conversation) => {
                        const channel = window.Echo.channel("chat." + conversation.id);
                        channel.listen(".message.sent", (data) => {
                            if (data.message) {
                                const messageDate = new Date(data.message.created_at);
                                const dateKey = this.formatDateKey(messageDate);
                                if (!this.messages[dateKey]) {
                                    this.$set(this.messages, dateKey, []);
                                }
                                const conversationIndex = this.conversations.findIndex(conv => conv.id === data.message.conversation_id);
                                if (conversationIndex !== -1) {
                                    const conversation = this.conversations[conversationIndex];
                                    conversation.messages = conversation.messages || [];
                                    this.conversations.splice(conversationIndex, 1);
                                    this.conversations.unshift(conversation);
                                    this.$set(this.conversations, 0, { ...conversation });
                                    this.$forceUpdate();
                                    if (this.activeConversation && this.activeConversation.id === data.message.conversation_id) {
                                        if (!this.messages[dateKey].some(msg => msg.id === data.message.id)) {
                                            if (!this.newMessageIndicator && data.message.sender_id !== this.loggedInUserId) {
                                                this.messages[dateKey].push({ id: "new-message-indicator", isIndicator: true });
                                                this.newMessageIndicator = true;
                                                setTimeout(() => {
                                                    this.messages[dateKey] = this.messages[dateKey].filter(msg => !msg.isIndicator);
                                                    this.newMessageIndicator = false;
                                                }, 10000);
                                            }
                                            this.markAsRead(conversation);
                                            this.messages[dateKey].push(data.message);
                                        }
                                    }
                                }
                                if (data.message.sender_id !== this.loggedInUserId && (!this.activeConversation || this.activeConversation.id !== data.message.conversation_id)) {
                                    const conv = this.conversations.find(conv => conv.id === data.message.conversation_id);
                                    if (conv) {
                                        conv.unreadCount = (conv.unreadCount || 0) + 1;
                                        this.$set(this.conversations, this.conversations.indexOf(conv), { ...conv });
                                    }
                                }
                            }
                        });
                    });
                    this.sortConversations();
                    const urlParams = new URLSearchParams(window.location.search);
                    const conversationId = urlParams.get("conversationId");
                    if (conversationId) {
                        this.selectConversationById(parseInt(conversationId, 10));
                    }
                    console.log('isChatActive after fetchConversations:', this.isChatActive);
                },
                (error) => {
                    console.error("Error fetching conversations:", error);
                }
            );
        },
        sortConversations() {
            this.conversations = [...this.conversations].sort((a, b) => {
                const lastMessageA = a.messages && a.messages.length > 0 ? a.messages[0].created_at : null;
                const lastMessageB = b.messages && b.messages.length > 0 ? b.messages[0].created_at : null;
                if (!lastMessageA) return 1;
                if (!lastMessageB) return -1;
                const timeA = new Date(lastMessageA).getTime();
                const timeB = new Date(lastMessageB).getTime();
                return timeB - timeA;
            });
            this.$forceUpdate();
        },
        markAsRead(conversation) {
            API.markAsRead(
                conversation.id,
                (data) => {
                    console.log("Messages marked as read:", data);
                },
                (error) => {
                    console.error("Error marking messages as read:", error);
                }
            );
        },
        loadMessages(conversation) {
            this.activeConversation = conversation;
            this.isChatActive = this.isMobileOrTablet; // Set isChatActive only on mobile/tablet
            console.log('isChatActive set to:', this.isChatActive, 'isMobileOrTablet:', this.isMobileOrTablet);
            conversation.unreadCount = 0;
            this.markAsRead(conversation);
            API.getMessages(
                conversation.id,
                (data) => {
                    const groupedMessages = {};
                    data.messages.forEach((message) => {
                        const messageDate = new Date(message.created_at);
                        const dateKey = this.formatDateKey(messageDate);
                        if (!groupedMessages[dateKey]) {
                            groupedMessages[dateKey] = [];
                        }
                        groupedMessages[dateKey].push(message);
                    });
                    this.messages = groupedMessages;
                    this.scrollToBottom();
                },
                (error) => {
                    console.error("Error fetching messages:", error);
                }
            );
        },
        formatDateKey(date) {
            const today = new Date();
            const yesterday = new Date();
            yesterday.setDate(today.getDate() - 1);
            if (date.toDateString() === today.toDateString()) {
                return this.$t('messages.today');
            } else if (date.toDateString() === yesterday.toDateString()) {
                return this.$t('messages.yesterday');
            } else {
                return date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
            }
        },
        formatShortDate(dateStr) {
            if (!dateStr) return '';
            if (typeof dateStr === 'string' && dateStr.includes('T')) {
                return dateStr.split('T')[0];
            }
            return dateStr;
        },
        formatMessageTime(timestamp) {
            const messageDate = new Date(timestamp);
            const hours = messageDate.getHours();
            const minutes = messageDate.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;
            const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
            return `${formattedHours}:${formattedMinutes} ${ampm}`;
        },
        sendMessage() {
            if (!this.newMessage.trim()) return;
            const sanitizedMessage = DOMPurify.sanitize(this.newMessage.trim());
            const holdMessage = sanitizedMessage;
            this.newMessage = "";

            const now = new Date();
            const dateKey = this.formatDateKey(now);
            const tempId = "temp_" + Date.now();

            const tempMessageObj = {
                id: tempId,
                sender_id: this.loggedInUserId,
                content: holdMessage,
                created_at: now.toISOString(),
                sending: true
            };

            if (!this.messages[dateKey]) {
                this.$set(this.messages, dateKey, []);
            }
            this.messages[dateKey].push(tempMessageObj);
            this.$set(this.messages, dateKey, [...this.messages[dateKey]]);
            this.scrollToBottom();

            API.sendMessage(
                this.activeConversation.id,
                { content: holdMessage },
                (data) => {
                    const arr = this.messages[dateKey] || [];
                    const index = arr.findIndex(m => m.id === tempId);
                    if (index !== -1) {
                        arr.splice(index, 1, data.message);
                    } else if (!arr.some((msg) => msg.id === data.message.id)) {
                        arr.push(data.message);
                    }
                    this.$set(this.messages, dateKey, [...arr]);
                    this.scrollToBottom();
                },
                (error) => {
                    console.error("Error sending message:", error);
                    const arr = this.messages[dateKey] || [];
                    this.$set(this.messages, dateKey, arr.filter(m => m.id !== tempId));
                }
            );
        },
        getSecondUserName(conversation) {
            if (!conversation || !conversation.participants) return "Unknown";
            const secondUser = conversation.participants.find(
                (participant) => String(participant.user_id) !== String(this.loggedInUserId)
            );
            return secondUser && secondUser.user ? secondUser.user.name : "Unknown";
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const chatBox = this.$refs.chatBox;
                if (chatBox) {
                    chatBox.scrollTop = chatBox.scrollHeight;
                }
            });
        },
        selectConversation(conversation) {
            console.log('Selecting conversation, isMobileOrTablet:', this.isMobileOrTablet);
            this.loadMessages(conversation);
        },
        resetChatState() {
            console.log('Resetting chat state, isMobileOrTablet:', this.isMobileOrTablet);
            this.isChatActive = false;
            this.activeConversation = null;
            this.messages = [];
        },
        selectConversationById(conversationId) {
            const conversation = this.conversations.find(conv => conv.id === conversationId);
            if (conversation) {
                console.log('Selecting conversation by ID:', conversationId);
                this.selectConversation(conversation);
            }
        },
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
            console.log('Window width updated:', this.windowWidth, 'isMobileOrTablet:', this.isMobileOrTablet);
            // Reset isChatActive if switching to desktop
            if (!this.isMobileOrTablet) {
                this.isChatActive = false;
            }
        },
        openCreateAgreementModal() {
            let myUser = null;
            try {
                myUser = JSON.parse(localStorage.getItem("user"));
            } catch (e) {
                console.warn("Failed to parse user from localStorage", e);
            }
            const myId = this.loggedInUserId;
            const myName = myUser ? (myUser.name || (myUser.first_name ? `${myUser.first_name} ${myUser.last_name || ''}` : "User")) : "User";

            const secondUserName = this.activeConversation ? this.getSecondUserName(this.activeConversation) : "";
            let secondUserId = null;
            if (this.activeConversation && this.activeConversation.participants) {
                const secondUser = this.activeConversation.participants.find(p => String(p.user_id) !== String(myId));
                if (secondUser) secondUserId = secondUser.user_id;
            }

            this.$refs.createAgreementModal.show({
                myId: myId,
                myName: myName,
                secondUserId: secondUserId,
                secondUserName: secondUserName
            });
        },
        handleAgreementCreated(agreementPayload) {
            const today = new Date();
            const dateKey = this.formatDateKey(today);
            if (!this.messages[dateKey]) {
                this.$set(this.messages, dateKey, []);
            }
            const newMessageObj = {
                id: agreementPayload.id || ("msg_agr_" + Date.now()),
                sender_id: this.loggedInUserId,
                type: "rental_agreement",
                rental_agreement_id: agreementPayload.id,
                content: "Rental Agreement Created: " + (agreementPayload.propertyTitle || agreementPayload.property_title),
                agreementData: agreementPayload,
                created_at: today.toISOString()
            };
            this.messages[dateKey].push(newMessageObj);
            this.$set(this.messages, dateKey, [...this.messages[dateKey]]);
            this.scrollToBottom();
        },
        openViewAgreementModal(agreementData, messageSenderId) {
            if (agreementData) {
                let currentUserId = this.loggedInUserId;
                if (!currentUserId) {
                    try {
                        const u = JSON.parse(localStorage.getItem("user"));
                        currentUserId = u ? (u.id || u.user_id || (u.user && u.user.id)) : null;
                    } catch (e) {
                        console.warn("Failed to parse user from localStorage", e);
                    }
                }
                const hostId = agreementData.host_id || agreementData.hostId || null;
                const tenantId = agreementData.tenant_id || agreementData.tenantId || null;
                
                let currentUserRole = "tenant"; // default
                if (hostId && currentUserId && String(hostId) === String(currentUserId)) {
                    currentUserRole = "host";
                } else if (tenantId && currentUserId && String(tenantId) === String(currentUserId)) {
                    currentUserRole = "tenant";
                } else if (hostId && currentUserId && String(hostId) !== String(currentUserId)) {
                    currentUserRole = "tenant";
                }
                this.$refs.viewAgreementModal.show(agreementData, currentUserRole);
            }
        },
        handleAgreementSigned(updatedAgreement) {
            Object.keys(this.messages).forEach(dateKey => {
                this.messages[dateKey].forEach(msg => {
                    if (msg.agreementData && msg.agreementData.id === updatedAgreement.id) {
                        this.$set(msg, "agreementData", { ...updatedAgreement });
                    }
                });
            });
        },
        isAgreementMessage(message) {
            if (!message) return false;
            return (
                message.type === 'rental_agreement' ||
                !!message.agreementData ||
                !!message.rental_agreement_id ||
                !!message.rental_agreement ||
                !!message.rentalAgreement ||
                (typeof message.content === 'string' && message.content.includes("Rental Agreement Created"))
            );
        },
        getAgreementObject(message) {
            if (!message) return null;
            if (message.agreementData) return message.agreementData;
            if (message.rental_agreement) return message.rental_agreement;
            if (message.rentalAgreement) return message.rentalAgreement;
            if (typeof message.content === 'string' && message.content.includes("Rental Agreement Created")) {
                const propTitle = message.content.replace("Rental Agreement Created for:", "").replace("Rental Agreement Created:", "").trim();
                return {
                    id: message.rental_agreement_id || (message.id ? message.id : "agr_preview"),
                    propertyTitle: propTitle || "Residential Property",
                    property_title: propTitle || "Residential Property",
                    monthlyRent: "3000.00",
                    monthly_rent: "3000.00",
                    startDate: "",
                    endDate: "",
                    status: "Pending Signature"
                };
            }
            return null;
        },
        isMyMessage(message) {
            if (!message || message.sender_id === undefined || message.sender_id === null) return false;
            const myId = this.loggedInUserId;
            if (!myId) return false;
            return String(message.sender_id) === String(myId);
        },
        getAgreementBadgeClass(agreementData) {
            if (!agreementData) return "badge-warning";
            if (agreementData.status === "Completed" || (agreementData.hostSigned && agreementData.tenantSigned)) {
                return "badge-success";
            }
            return "badge-warning";
        },
        getAgreementPdfUrl(agreementData) {
            if (!agreementData || !agreementData.id) return null;
            return API.getRentalAgreementPdfUrl(agreementData.id);
        },
    },
    watch: {
        messages: {
            handler() {
                this.scrollToBottom();
            },
            deep: true
        },
        searchQuery() {
            this.$nextTick(() => {
                console.log('searchQuery changed, isChatActive:', this.isChatActive, 'isMobileOrTablet:', this.isMobileOrTablet);
                this.$emit('update-chat-widget');
            });
        },
        filteredConversations: {
            handler() {
                this.$nextTick(() => {
                    console.log('filteredConversations changed, isChatActive:', this.isChatActive, 'isMobileOrTablet:', this.isMobileOrTablet);
                    this.$emit('update-chat-widget');
                    this.scrollToBottom();
                });
            },
            deep: true
        }
    },
    created() {
        this.initializeEcho();
        this.fetchConversations();
        console.log('Component created, initial isChatActive:', this.isChatActive, 'isMobileOrTablet:', this.isMobileOrTablet);
        // Add window resize listener
        window.addEventListener('resize', this.updateWindowWidth);
    },
    beforeDestroy() {
        if (this.channel) {
            this.channel.unsubscribe();
        }
        // Remove window resize listener
        window.removeEventListener('resize', this.updateWindowWidth);
    }
};
</script>

<style scoped>
.chat-widget.mobile-active .tab-content {
    display: block !important;
}

.chat-widget .mb-search-box {
    display: block;
    /* Ensure search bar is visible when rendered */
}

.chat-widget .back-arrow {
    display: block;
    cursor: pointer;
    font-weight: bold;
    margin-bottom: 10px;
    padding: 15px;
}

@media (min-width: 992px) {
    .chat-widget .back-arrow {
        display: none !important;
        /* Hide back button on desktop */
    }

    .chat-widget .mb-search-box {
        display: block !important;
        /* Always show search bar on desktop */
    }

    .chat-widget .nav-item.inactive {
        display: block !important;
        /* Ensure nav-items are not hidden on desktop */
    }
}

@media (max-width: 991px) {
    .chat-widget .mb-search-box {
        display: block;
        /* Show search bar when v-if allows */
    }

    .chat-widget.mobile-active .mb-search-box {
        display: none !important;
        /* Hide search bar when chat is active on mobile/tablet */
    }
}

/* Existing styles (unchanged except for cleanup) */
.chat-widget .nav.nav-pills {
    padding: 0px 22px 30px;
    background-color: white;
    display: block;
    max-height: 500px;
    overflow-y: auto;
}

.chat-widget .card {
    border: 0;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.chat-widget .nav.nav-pills .nav-item .nav-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    background: #ededed;
    border: 1px solid #fff;
    border-radius: 10px;
    font-weight: bold;
    letter-spacing: 0.3px;
}

.chat-widget .nav.nav-pills .nav-item .nav-link>div img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 12px;
}

.chat-widget .nav.nav-pills .nav-item .nav-link.active {
    background: rgb(112 211 255);
    color: white;
    border: 1px solid rgb(112 211 255);
}

.chat-widget .tab-content.col {
    min-height: 650px;
    padding: 0;
    background: #F8F8F8;

}

.chat-widget .card .card-body {
    padding: 15px;
    height: 100%;
}

.chat-widget .card .card-body .card-text {
    height: 100%;
}

.chat-widget .single-chat-header {
    background-color: #70d3ff;
    font-weight: bold;
    padding: 8px 15px;
    color: white;
    border-radius: 4px;
    letter-spacing: 0.3px;
}

.chat-widget .chat-box {
    max-height: calc(500px - 12px);
    overflow-y: auto;
    margin-top: 10px;
    padding: 15px 20px 0px;
}

/* width */
.chat-widget ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

/* Track */
.chat-widget ::-webkit-scrollbar-track {
    background: #ebebeb;
}

/* Handle */
.chat-widget ::-webkit-scrollbar-thumb {
    background: #d7d7d7;
}

/* Handle on hover */
.chat-widget ::-webkit-scrollbar-thumb:hover {
    background: #d7d7d7;
}

.chat-widget .message-text {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    border: 1px solid #D7D7D7;
    background: white;
    padding: 10px 15px;
    border-radius: 10px;
    max-width: 530px;
    width: fit-content;
    position: relative;
    margin-bottom: 30px;
    letter-spacing: 0.3px;
    color: #000000;
    margin-left: auto;
}

.chat-widget .message-text.send {
    background: #F0F0F0;
    margin-left: 0;
    color: #000;
}

.chat-widget .single-chat-footer {
    position: absolute;
    z-index: 111;
    background: transparent;
    width: calc(100% - 30px);
    left: 0;
    padding: 12px;
    bottom: 15px;
    right: 0;
    margin: auto;
    border-radius: 4px;
    display: flex;
}

.chat-widget textarea.form-control {
    height: 50px;
    line-height: 31px;
    font-size: 14px;
    color: #333;
    border: 0;
    letter-spacing: 0.3px;
    font-weight: 400;
    border-radius: 10px;
    padding: 8px 20px;
    padding-right: 20px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #E6E6E6;
}

.chat-widget textarea.form-control::placeholder {
    color: #333;
}

.chat-widget .send-message button {
    background: #70d3ff;
    border: 0;
    height: 50px;
    width: 50px;
    border-radius: 10px;
    margin-left: 10px;
}

.chat-widget .send-message button svg {
    width: 18px;
    margin-left: -3px;
}

.chat-widget .send-message button svg path {
    fill: white;
}

.chat-widget .write-message {
    flex: 1;
}

.single-chat-header img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 12px;
}

.chat-widget .tab-pane.active .chat-box .message-text {
    animation: myAnim 0.5s ease 0s 1 normal forwards;
}

@keyframes myAnim {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.message-list span {
    font-size: 16px;
}


@media (max-width: 991px) {
    .chat-widget .card .col-auto.w-25 {
        width: 35% !important;
    }
}

@media (max-width: 767px) {
    .chat-widget .card .col-auto.w-25 {
        width: 100% !important;
    }

    .chat-widget .nav.nav-pills {
        padding: 15px 15px 0px;
        background-color: #ffffff;
        max-height: 500px;
        display: flex;
        flex-direction: row !important;
        flex-wrap: nowrap;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
    }

    .chat-widget .nav.nav-pills .nav-item {
        min-width: 175px;
        margin-right: 10px;
        scroll-snap-align: center;
    }
}

.chat-widget-wrap {
    max-width: 1400px;
    margin: 0 auto;
    min-height: calc(100vh - 197px);
}

.chat-widget-wrap .col-auto {
    width: 30%;
    border-right: 1px solid #D7D7D7;
}

.tabs {
    border: 1px solid #D7D7D7;
    border-radius: 20px;
    overflow: hidden;
    min-height: 650px;
}

.chat-widget .nav.nav-pills .nav-item .nav-link.active {
    background: #f8f8f8;
    color: #333333;
    border: 0px;
    border-bottom: 1px solid #D7D7D7;
    transition: all 0.1s ease-in;
}

.chat-widget .nav.nav-pills .nav-item .nav-link,
.chat-widget .single-chat-header {
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 23.44px;
    border-bottom: 1px solid #D7D7D7;
    background: transparent;
    border-radius: 0px;
    cursor: pointer;
    padding: 15px 0px;
    color: #333333;
}

.message-heading {
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 29.3px;
    padding: 10px 22px;
    border-bottom: 1px solid #D7D7D7;
    min-height: auto;
}

.chat-widget .single-chat-header {
    padding: 12px 20px;
    min-height: auto;
    background: white;
}

.chat-widget .single-chat-header span {
    font-size: 16px;
}

.date-box {
    font-family: "Roboto", sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    background: white;
    padding: 10px 30px;
    border-radius: 50px;
    width: fit-content;
    margin: 0 auto 00px;
}

.message-badge {
    font-family: "Roboto", sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 17.58px;
    color: white;
    background: #70D3FF;
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 24px;
    height: 24px;
    border-radius: 50%;
}

.search-box {
    padding: 20px 22px 10px;
}

.search-box input[type=text] {
    width: 100%;
    box-sizing: border-box;
    background-color: white;
    background-image: url(/img/search-ic.61c9605b.svg);
    background-position: 15px 12px;
    background-repeat: no-repeat;
    padding: 12px 20px 12px 45px;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.2;
    border: 1px solid #D7D7D7;
    border-radius: 10px;
    background-size: 18px;
}

.date-box.new-message,
.message-text.new-message-indicator {
    background: #ff000d;
    padding: 10px 10px 20px;
    display: block;
    width: 100%;
    max-width: 100%;
    height: 2px;
    color: transparent;
    padding: 0;
}

.message-text.new-message-indicator span {
    color: #ff000d;
    background: #f8f8f8;
    padding: 10px;
    margin-top: -21px;
    display: block;
    width: fit-content;
    margin-inline: auto;
    font-size: 13px;
    border-radius: 10px;
}

.chat-tab-content {
    position: relative;
    max-width: 100%;
    flex-grow: 1;
}

.card-box {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    border-radius: 10px;
    padding: 30px 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    flex-direction: column;
    width: 80%;
}

.card-box p {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 4px;
}

@media (max-width: 1401px) {

    .chat-widget .nav.nav-pills .nav-item .nav-link,
    .chat-widget .single-chat-header {
        font-size: 18px;
    }

    .message-badge {
        font-size: 12px;
    }
}

@media (max-width: 991px) {
    .chat-widget-wrap .col-auto {
        width: 36%;
    }

    .chat-widget .nav.nav-pills .nav-item .nav-link,
    .chat-widget .single-chat-header,
    .search-box input[type=text] {
        font-size: 16px;
    }

    .chat-widget .single-chat-header {
        min-height: 75px;
    }

    .date-box {
        font-size: 13px;
        padding: 10px 30px;
        margin: 0 auto 15px;
    }

    .chat-widget .message-text {
        margin-bottom: 15px;
    }

    .search-box {
        padding: 20px 22px 15px;
    }
}

@media (max-width: 767px) {
    .chat-tab-content {
        position: static !important;
    }

    .chat-text {
        display: none;
    }

    .chat-widget-wrap .col-auto {
        width: 100%;
    }

    .chat-widget textarea.form-control {
        padding-right: 20px;
    }

    .chat-widget .single-chat-footer {
        width: calc(100% - 20px);
    }

    .chat-widget .nav.nav-pills .nav-item .nav-link {
        padding: 10px;
    }

    .chat-widget .nav.nav-pills .nav-item {
        margin-right: 0px;
    }

    .h-100 {
        height: auto !important;
    }

    .chat-widget .nav.nav-pills .nav-item .nav-link,
    .chat-widget .nav.nav-pills .nav-item .nav-link.active {
        border-bottom: 0px;
    }

    .chat-widget .single-chat-header {
        display: none;
    }

    .chat-widget .nav.nav-pills .nav-item:not(:last-child) {
        margin-bottom: 0px;
    }

    .chat-widget-wrap {
        padding: 0;
    }

    .chat-widget .nav.nav-pills {
        padding: 15px 0px 0px;
    }

    .chat-widget .chat-box {
        max-height: calc(560px - 170px);
        padding: 15px 15px 0px;
    }

    .message-text.new-message-indicator {
        margin-block: 30px;
    }

    .search-box {
        padding: 15px;
    }

    .chat-widget .tab-content.col {
        min-height: 490px;
    }

    .chat-widget .nav.nav-pills .nav-item .nav-link>div img {
        width: 35px;
        height: 35px;
        margin-right: 10px;
    }
}

.message-time {
    text-align: right;
    font-size: 10px;
    color: #b9b9b9;
}

.message-text {
    padding-bottom: 0px !important;
    padding-right: 10px !important;
}

.bottom-head {
    display: none;
}

.new-message-indicator {
    text-align: center;
    background-color: #ffde59;
    color: #333;
    font-weight: bold;
    padding: 5px;
    margin: 5px 0;
    border-radius: 5px;
    animation: fadeOut 3s forwards;
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>